// ----------------------------------------------------------------------------
// Snippet: Header menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_header-menu.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var HAMBURGER_SELECTOR = '.header__link--menu';
var HEADER_NAV_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_LIST_SELECTOR = '.header-menu__list';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MOBILE_MENU_ITEM_SELECTOR = '.header-menu__list--mobile .header-menu__item--dropdown';
var OPEN_MENU_ITEM_SELECTOR = '.header-menu__item--dropdown.js--is-open';
var DESKTOP_TOP_MENU_ITEM_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown';
var MENU_BUTTON_SELECTOR = '.header-menu__button';
var MOBILE_MENU_BUTTON_SELECTOR = '.header-menu__list--mobile .header-menu__button';
var DESKTOP_MENU_BUTTON_SELECTOR = '.header-menu__list--desktop .header-menu__button';
var MOBILE_MENU_LINK_SELECTOR = '.header-menu__list--mobile .header-menu__link';
var DESKTOP_MENU_LINK_SELECTOR = '.header-menu__list--desktop .header-menu__link';
var MENU_BACK_BUTTON_SELECTOR = '.header-menu__back .back__button';

// Classes
var HEADER_NAV_WRAPPER_SLIDE_CLASS = 'mobile-slide';
var LEVEL_1_MENU_ITEM_CLASS = 'header-menu__item--level-1';
var LEVEL_2_MENU_LIST_CLASS = 'header-menu__list--level-2';
var MENU_BUTTON_CLASS = 'header-menu__button';
var MENU_BACK_BUTTON_CLASS = 'back__button';
var MENU_LINK_EMPTY_CLASS = 'header-menu__link--empty';
var OPEN_CLASS = 'js--is-open';
var NO_SCROLL_CLASS = 'noscroll';

// Key codes
var INTERACTION_KEYS = [' ', 'Enter', 'Escape', 'Tab'];

// -------------------------------------
// Helper functions
// -------------------------------------

function initMobileMenu() {
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $headerNavWrapper: document.querySelector(HEADER_NAV_WRAPPER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MOBILE_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MOBILE_MENU_BUTTON_SELECTOR),
    $links: document.querySelectorAll(MOBILE_MENU_LINK_SELECTOR)
  };
  initMenuButtons(menu, 'mobile');
  initMenuLinks(menu, 'mobile');
}
function initDesktopMenu() {
  var menu = {
    $topLevelItems: document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(DESKTOP_MENU_BUTTON_SELECTOR),
    $links: document.querySelectorAll(DESKTOP_MENU_LINK_SELECTOR)
  };
  initDesktopHover(menu.$topLevelItems);
  initMenuButtons(menu, 'desktop');
  initMenuLinks(menu, 'desktop');
}
function initMenuButtons(menu, source) {
  menu.$buttons.forEach(function (button) {
    button.menu = menu;
    button.source = source;
    button.type = 'button';
    button.addEventListener('click', handleClick);
    button.addEventListener('keydown', handleKeydown);
  });

  // If we're on mobile and using the slide layout, initialize back buttons
  if (source === 'mobile' && menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
    var backButtons = document.querySelectorAll(MENU_BACK_BUTTON_SELECTOR);
    backButtons.forEach(function (button) {
      button.menu = menu;
      button.source = source;
      button.type = 'back-button';
      button.addEventListener('click', handleClick);
      button.addEventListener('keydown', handleKeydown);
    });
  }
}
function initMenuLinks(menu, source) {
  menu.$links.forEach(function (link) {
    link.menu = menu;
    link.source = source;
    link.type = 'link';
    link.addEventListener('click', handleClick);
    link.addEventListener('keydown', handleKeydown);
    link.addEventListener('focus', handleFocus);
  });
}
function initDesktopHover(topLevelItems) {
  topLevelItems.forEach(function (item) {
    item.addEventListener('mouseenter', handleHover);
    item.addEventListener('mouseleave', handleHover);
  });
}
function handleClick(event) {
  var $this = event.currentTarget;
  event.stopPropagation();
  if ($this.type === 'button') {
    handleMenuButtonInteraction($this, event);
  } else if ($this.type === 'back-button') {
    var item = event.target.closest(MENU_ITEM_SELECTOR);
    var button = event.currentTarget;
    closeDropdown(item, button);
  } else {
    handleMenuLinkInteraction($this, event);
  }
}
function handleKeydown(event) {
  event.stopPropagation();
  handleKeyboardInteraction(event.currentTarget, event);
}
function handleFocus(event) {
  var $this = event.currentTarget;
  var parentItem = $this.parentElement;
  if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
    if ($this.menu.$topLevelItems) {
      $this.menu.$topLevelItems.forEach(function (item) {
        var childButton = item.querySelector(MENU_BUTTON_SELECTOR);
        closeDropdown(item, childButton);
      });
    }
  }
}
function handleHover(event) {
  var $this = event.currentTarget;
  var button = $this.querySelector(MENU_BUTTON_SELECTOR);
  if (event.type === 'mouseenter') {
    setTimeout(openDropdown($this, button), 80);
  } else {
    setTimeout(closeDropdown($this, button), 80);
  }
}
function handleMenuButtonInteraction(button, event) {
  event.preventDefault();
  var parentItem = button.closest(MENU_ITEM_SELECTOR);
  if (parentItem.classList.contains(OPEN_CLASS)) {
    closeDropdown(parentItem, button);
  } else {
    openDropdown(parentItem, button);

    // If we're using the slide layout and the button is top level, move focus to child
    // level back button
    if (button.source === 'mobile') {
      if (button.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
        if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
          var backButton = parentItem.querySelector(MENU_BACK_BUTTON_SELECTOR);

          // Delay setting the focus so that there's time for it to become visible
          setTimeout(function () {
            backButton.focus();
          }, 30);
        }
      }
    }
  }
}
function handleMenuLinkInteraction(link, event) {
  var href = link.getAttribute('href');
  var path = window.location.pathname;
  var isCurrentLink = href === path;

  // Empty links (e.g. href="#") are the text label of a dropdown parent —
  // toggle the dropdown exactly like its arrow button rather than navigating.
  if (link.classList.contains(MENU_LINK_EMPTY_CLASS)) {
    event.preventDefault();
    var parentItem = link.closest(MENU_ITEM_SELECTOR);
    var button = parentItem.querySelector(MENU_BUTTON_SELECTOR);
    handleMenuButtonInteraction(button, event);
    return;
  }
  if (isCurrentLink) {
    event.preventDefault();
    if (link.source === 'mobile') {
      closeMenu(link.menu);
    } else {
      var topLevelItem = link.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
      var _button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);
      closeDropdown(topLevelItem, _button);
    }
  } else {
    if (event.key === ' ') {
      event.preventDefault();
      window.location.assign(href);
    }
  }
}
function handleKeyboardInteraction(element, event) {
  var key = event.key;
  if (INTERACTION_KEYS.includes(key)) {
    if (key === ' ' || key === 'Enter') {
      // If the current element is a button, toggle the dropdown
      // If it's a back button, close the current dropdown and move focus back to the parent
      // Otherwise, it's a link
      if (element.classList.contains(MENU_BUTTON_CLASS)) {
        handleMenuButtonInteraction(element, event);
      } else if (element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
        var parentItem = element.closest(MENU_ITEM_SELECTOR);
        var parentButton = parentItem.querySelector(MENU_BUTTON_SELECTOR);
        parentButton.focus();
        handleMenuButtonInteraction(element, event);
      } else if (key === 'Enter') {
        handleMenuLinkInteraction(element, event);
      }
    } else if (key === 'Escape') {
      // Find the closest parent dropdown, close it, and focus the associated button
      if (element.source === 'mobile') {
        var closestOpenDropdown;
        if (element.classList.contains(MENU_BUTTON_CLASS) || element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
          closestOpenDropdown = element.closest(OPEN_MENU_ITEM_SELECTOR);
        } else {
          closestOpenDropdown = element.closest(MENU_ITEM_SELECTOR);
        }
        if (closestOpenDropdown !== null) {
          var button = closestOpenDropdown.querySelector(MENU_BUTTON_SELECTOR);
          closeDropdown(closestOpenDropdown, button);
          button.focus();
        } else {
          closeMenu(element.menu);
        }
      } else {
        var topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
        var _button2 = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);
        closeDropdown(topLevelItem, _button2);
        _button2.focus();
      }
    } else if (key === 'Tab') {
      // If we're on mobile, using the slide layout, and inside a level 2 menu, keep tab focus
      // from leaving the menu
      if (element.source === 'mobile') {
        if (element.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
          var parentList = element.closest(MENU_LIST_SELECTOR);
          if (parentList.classList.contains(LEVEL_2_MENU_LIST_CLASS)) {
            var $this = event.target;
            var focusableElements = parentList.querySelectorAll('[tabindex="0"]');
            var firstFocusableElement = focusableElements[0];
            var lastFocusableElement = focusableElements[focusableElements.length - 1];
            if (event.shiftKey) {
              if ($this === firstFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
              }
            } else if ($this === lastFocusableElement) {
              event.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      }
    }
  }
}
function closeMenu(menu) {
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$header.classList.remove(OPEN_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
}
function openDropdown(item, button) {
  item.classList.add(OPEN_CLASS);
  button.setAttribute('aria-expanded', 'true');
}
function closeDropdown(item, button) {
  var childList = item.querySelector(MENU_LIST_SELECTOR);
  var childListDropdownItems = childList.querySelectorAll(MENU_ITEM_SELECTOR);
  item.classList.remove(OPEN_CLASS);
  button.setAttribute('aria-expanded', 'false');
  if (childListDropdownItems !== null) {
    childListDropdownItems.forEach(function (item) {
      var button = item.querySelector(MENU_BUTTON_SELECTOR);
      item.classList.remove(OPEN_CLASS);
      button.setAttribute('aria-expanded', 'false');
    });
  }
}
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var mobileMedia = window.matchMedia('(max-width: 1023px)');
  if (mobileMedia.matches) {
    initMobileMenu();
  } else {
    initDesktopMenu();
  }
});
window.addEventListener('resize', function () {
  var mobileMedia = window.matchMedia('(max-width: 1023px)');
  if (mobileMedia.matches) {
    initMobileMenu();
  } else {
    initDesktopMenu();
  }
});